import gql from 'graphql-tag';

export default id => gql`
  query {
    getDependencyById(input: { id: "${id}" }) {
      id
      bundleId,
      packageId
      startDate
      endDate
      name
      dependencyLists {
        index
        bundleId
        packageId
        name
        type
      }
    }
  }
`;
